import { createRouter, createWebHistory } from '@ionic/vue-router';
import store from '@/store';
import Tabs from '@/views/Tabs';
import CompetitionFormTabs from '@/views/competition/FormTabs';

// Definiraj routeeve za aplikaciju.
// Početna strana aplikacije vodi na tab s natjecanjima.
// meta "guest" govori da je route dostupan samo korisnicima koji nisu prijavljeni.
// meta "auth" govori da je za route potrebna prijava.
// meta "hideTabBar" govori da se izbornik ne prikazuje na routeu.

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/tabs/competitions',
        meta: { guest: true },
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/login',
        name: 'login',
        meta: { guest: true },
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        meta: { guest: true },
        component: () => import('@/views/ForgotPassword.vue')
    },
    {
        path: '/request-access',
        name: 'request-access',
        meta: { guest: true },
        component: () => import('@/views/RequestAccess.vue')
    },
    {
        path: '/reset-password/:token/:email/:new?',
        name: 'reset-password',
        meta: { guest: true },
        component: () => import('@/views/ResetPassword.vue')
    },
    {
        path: '/tabs/',
        component: Tabs,
        children: [
            {
                path: '',
                redirect: 'competitions'
            },
            {
                path: 'competitions',
                name: 'competitions',
                meta: { main: true },
                component: () => import('@/views/competition/Index.vue')
            },
            {
                path: 'competitions/view/:id',
                name: 'view-competition',
                component: () => import('@/views/competition/View.vue')
            },
            {
                path: 'competitions/form',
                name: 'competition-form',
                redirect: '/tabs/competitions/form/general',
                meta: { auth: true },
                component: CompetitionFormTabs,
                children: [
                    {
                        path: 'general/:id?',
                        name: 'competition-form-general',
                        meta: { step: 'general', hideTabBar: true },
                        component: () => import('@/views/competition/FormGeneral.vue')
                    },
                    {
                        path: 'judges/:id',
                        name: 'competition-form-judges',
                        meta: { step: 'judges', hideTabBar: true },
                        component: () => import('@/views/competition/FormJudges.vue')
                    },
                    {
                        path: 'participants/:id',
                        name: 'competition-form-participants',
                        meta: { step: 'participants', hideTabBar: true },
                        component: () => import('@/views/competition/FormParticipants.vue')
                    },
                    {
                        path: 'results/:id',
                        name: 'competition-form-results',
                        meta: { step: 'results', hideTabBar: true },
                        component: () => import('@/views/competition/FormResults.vue')
                    }
                ]
            },
            {
                path: 'competitions/admins/:id',
                name: 'competition-admins',
                meta: { auth: true, hideTabBar: true },
                component: () => import('@/views/competition/Admins.vue')
            },
            {
                path: 'competitions/tie-break/:competitionId/:tieBreakId',
                name: 'competition-tie-break',
                meta: { auth: true, hideTabBar: true },
                component: () => import('@/views/competition/TieBreak.vue')
            },
            {
                path: 'competitions/live-results/:id/:filter',
                name: 'competition-live-results',
                meta: { hideTabBar: true },
                component: () => import('@/views/competition/LiveResults.vue')
            },
            {
                path: 'settings',
                meta: { main: true, auth: true },
                component: () => import('@/views/Settings.vue')
            },
            {
                path: 'fake',
                component: () => import('@/views/competition/Index.vue')
            }
        ],
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, _from, next) => {
    await store.dispatch('auth/loginFromStorage');

    // Zabrani određene routeve ovisno o tome je li korisnik prijavljen.
    const loggedIn = store.getters['auth/isLoggedIn'];

    if(to.matched.some(r => r.meta.auth) && !loggedIn) return next({ name: 'login' });
    if(to.matched.some(r => r.meta.guest) && loggedIn) return next({ name: 'competitions' });

    next();
})

export default router;